const NOTICE_POPUP_STORAGE_PREFIX = 'FTZINC:notice-popup:'

function getLocalDate() {
  const now = new Date()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${now.getFullYear()}-${month}-${day}`
}

function getViewerId(token, email) {
  if (!token) return 'guest'

  const identity = String(email || token).trim().toLowerCase()
  return `user-${encodeURIComponent(identity)}`
}

function getStorageKey(token, email) {
  return `${NOTICE_POPUP_STORAGE_PREFIX}${getViewerId(token, email)}`
}

export function hasSeenNoticePopup(noticeId, token, email) {
  if (noticeId === undefined || noticeId === null) return false

  try {
    const saved = JSON.parse(localStorage.getItem(getStorageKey(token, email)) || 'null')
    return saved?.date === getLocalDate() && String(saved.noticeId) === String(noticeId)
  } catch (error) {
    console.warn('Unable to read notice popup state', error)
    return false
  }
}

export function markNoticePopupSeen(noticeId, token, email) {
  if (noticeId === undefined || noticeId === null) return

  try {
    localStorage.setItem(getStorageKey(token, email), JSON.stringify({
      date: getLocalDate(),
      noticeId,
    }))
  } catch (error) {
    console.warn('Unable to save notice popup state', error)
  }
}
